import { render, staticRenderFns } from "./crm-create_injury.vue?vue&type=template&id=68e0751c&"
import script from "./crm-create_injury.vue?vue&type=script&lang=js&"
export * from "./crm-create_injury.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports